import unescape from './helpers/unescape';

const translations = {};

export const bulkAdd = (toAdd) => { Object.assign(translations, toAdd); };

export const translate = (key, ...rest) => {
  // BvApi.t receives an object, while $.t was receiving an array.
  // We will know support both and will convert to array if an object is received
  // When interpolation is improved, an object should be preferred
  // Now it is not possible to change the order of the interpolated values via translations
  const options = (typeof rest[rest.length - 1] === 'object') ? rest[rest.length - 1] : null;

  if (!(key in translations)) return (options && options.default) ? options.default : key;

  const translation = translations[key];

  return unescape(
    typeof translation === 'function' ? (
      translation(...(options ? Object.values(options) : rest))
    ) : translation,
  );
};

export const exist = (key) => !!translations[key];

// Receives a string and returns a function
// Used by $.t.format
// Improvement: The backend should send the string with %{var} as it's in database
// And do all work here, replacing it by values
export const interpolate = (string) => (...args) => (
  args.reduce((accum, value, index) => (
    accum.replace(new RegExp(`\\{${index}\\}`, 'g'), value)
  ), string)
);
